import React, { useState } from "react";
import { X } from "lucide-react";
import { isKarimeSaysAnniversaryWeek } from "../utils/dateUtils";

const ANNIVERSARY_VIDEO_URL =
  "https://res.cloudinary.com/dbvqeiqxb/video/upload/q_auto/v1779763868/trim_0DFF4201-5E7F-4809-A056-8D2608676D38_ylqzjy.mp4";

const AnniversaryBanner = () => {
  const [showModal, setShowModal] = useState(false);
  const [ripples, setRipples] = useState([]);

  if (!isKarimeSaysAnniversaryWeek()) return null;

  const handleBannerClick = (e) => {
    const rect = e.currentTarget.getBoundingClientRect();
    const x = e.clientX - rect.left;
    const y = e.clientY - rect.top;
    const id = Date.now();
    setRipples((r) => [...r, { x, y, id }]);
    setTimeout(() => setRipples((r) => r.filter((rip) => rip.id !== id)), 550);
    setTimeout(() => setShowModal(true), 200);
  };

  return (
    <>
      <style>{`
        @keyframes annivGlow {
          0%, 100% { box-shadow: 0 2px 10px rgba(236,72,153,0.35); }
          50%       { box-shadow: 0 2px 20px rgba(236,72,153,0.65); }
        }
        @keyframes sparkleFloat {
          0%, 100% { transform: translateY(0px) rotate(0deg); }
          33%       { transform: translateY(-2px) rotate(6deg); }
          66%       { transform: translateY(1px) rotate(-4deg); }
        }
        @keyframes annivRipple {
          to { transform: scale(4); opacity: 0; }
        }
        .anniv-ripple-btn { position: relative; overflow: hidden; }
        .anniv-ripple-btn .anniv-ripple {
          position: absolute;
          border-radius: 50%;
          width: 80px; height: 80px;
          margin-top: -40px; margin-left: -40px;
          background: rgba(255,255,255,0.25);
          transform: scale(0);
          animation: annivRipple 0.5s linear;
          pointer-events: none;
        }
        .anniv-glow { animation: annivGlow 2.5s ease-in-out infinite; }
        .sparkle-float { animation: sparkleFloat 2.2s ease-in-out infinite; }
      `}</style>

      {/* Banner */}
      <button
        onClick={handleBannerClick}
        className="anniv-ripple-btn anniv-glow w-full flex items-center gap-3 px-4 py-2 border-b border-white/10 font-quicksand"
        style={{
          background: "linear-gradient(135deg, #9d174d, #be185d, #db2777)",
        }}
      >
        {ripples.map(({ x, y, id }) => (
          <span key={id} className="anniv-ripple" style={{ left: x, top: y }} />
        ))}
        <span className="sparkle-float" style={{ fontSize: "15px" }}>
          ✨
        </span>
        <div className="text-left flex-1">
          <p className="text-white font-bold text-sm leading-tight">
            Karime Says cumple 1 año 🩵
          </p>
          <p className="text-pink-200 text-[10px]">
            Toca para ver un momento muy especial...
          </p>
        </div>
        <span className="text-pink-200 text-sm">→</span>
      </button>

      {/* Bottom sheet modal */}
      {showModal && (
        <div
          className="fixed inset-0 z-50 flex items-end justify-center"
          style={{ background: "rgba(0,0,0,0.75)" }}
          onClick={() => setShowModal(false)}
        >
          <div
            className="w-full font-quicksand rounded-t-3xl overflow-y-auto"
            style={{
              background: "#1e0715",
              border: "1px solid rgba(236,72,153,0.25)",
              maxHeight: "90vh",
            }}
            onClick={(e) => e.stopPropagation()}
          >
            {/* Handle bar */}
            <div className="flex justify-center pt-3 pb-1">
              <div
                className="w-10 h-1 rounded-full"
                style={{ background: "rgba(236,72,153,0.3)" }}
              />
            </div>

            {/* Header */}
            <div className="relative px-6 pt-4 pb-3">
              <button
                onClick={() => setShowModal(false)}
                className="absolute top-4 right-4 w-8 h-8 rounded-full flex items-center justify-center active:scale-90 transition-transform"
                style={{ background: "rgba(255,255,255,0.1)" }}
              >
                <X size={16} color="white" />
              </button>
              <h2
                className="text-white font-bold text-xl leading-tight pr-10"
                style={{ textShadow: "0 0 20px rgba(236,72,153,0.4)" }}
              >
                ✨ 1 año de Karime Says
              </h2>
            </div>

            {/* Body */}
            <div className="px-6 pb-10 flex flex-col gap-4">
              <p className="text-pink-100 text-sm leading-relaxed">
                Lo que empezó como una app para divertirnos entre perrisimxs…
                terminó convirtiéndose en uno de los proyectos más especiales de
                mi vida 💖
              </p>
              <p className="text-pink-100 text-sm leading-relaxed">
                Gracias por jugar, compartir frases, mandar trends y apoyar este
                rinconcito de internet durante este primer año 🫶
              </p>
              <p className="text-pink-100 text-sm leading-relaxed">
                Y claro, gracias también a Kari por tantas risas, frases
                icónicas y momentos que inspiraron esta app 💖
              </p>
              <p className="text-pink-100 text-sm leading-relaxed">
                PD: sí… Kari vio la app 😭✨
              </p>

              {/* Video */}
              {ANNIVERSARY_VIDEO_URL ? (
                <div
                  className="rounded-2xl overflow-hidden mt-6"
                  style={{ border: "1px solid rgba(236,72,153,0.35)" }}
                >
                  <video
                    src={ANNIVERSARY_VIDEO_URL}
                    controls
                    playsInline
                    preload="metadata"
                    className="w-full rounded-2xl"
                  />
                </div>
              ) : (
                <div
                  className="rounded-2xl flex items-center justify-center py-10"
                  style={{
                    background: "rgba(236,72,153,0.07)",
                    border: "1px solid rgba(236,72,153,0.2)",
                  }}
                >
                  <p className="text-pink-300 text-sm text-center">
                    🎬 El video llega pronto 💖
                  </p>
                </div>
              )}

              {/* Mensaje final */}
              <div
                className="rounded-2xl px-5 py-4 flex flex-col gap-1 mt-4"
                style={{
                  background: "rgba(236,72,153,0.09)",
                  border: "1px solid rgba(236,72,153,0.2)",
                }}
              >
                <p className="text-pink-200 text-sm text-center leading-relaxed">
                  Gracias por ser parte de este primer año 💖
                </p>
                <p className="text-pink-200 text-sm text-center leading-relaxed">
                  Se vienen más cositas divertidas ✨
                </p>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default AnniversaryBanner;
